import { render } from "./BaseSmallButton.vue?vue&type=template&id=cf611204&scoped=true"
import script from "./BaseSmallButton.vue?vue&type=script&lang=js"
export * from "./BaseSmallButton.vue?vue&type=script&lang=js"

import "./BaseSmallButton.vue?vue&type=style&index=0&id=cf611204&scoped=true&lang=scss"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf611204"],['__file',"src/components/helpers/BaseSmallButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf611204"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf611204', __exports__)) {
    console.log('reload')
    api.reload('cf611204', __exports__)
  }
  
  module.hot.accept("./BaseSmallButton.vue?vue&type=template&id=cf611204&scoped=true", () => {
    console.log('re-render')
    api.rerender('cf611204', render)
  })

}


export default __exports__